import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './resources/HeroSection';
import { IntroSection } from './resources/IntroSection';
import { PartnerGridSection } from './resources/PartnerGridSection';
export function ResourcesPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-880">
      <Navbar data-id="element-881" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-882">
        <HeroSection data-id="element-883" />
        <IntroSection data-id="element-884" />
        <PartnerGridSection data-id="element-885" />
      </main>
      <Footer data-id="element-886" />
    </div>;
}